<template>
	<v-card>
		<v-toolbar flat color="dark" dark>
			<v-toolbar-title>
				<span class="pl-2">Medewerker sector</span>
			</v-toolbar-title>
		</v-toolbar>
		<v-card-title>
			<v-text-field v-model="search" append-icon="mdi-magnify" label="Filter" single-line hide-details></v-text-field>
		</v-card-title>

		<v-alert v-if="loadError" type="error" dense outlined class="mx-4 mb-0">
			{{ loadError }}
		</v-alert>

		<v-data-table :headers="headers" :items="data" :search="search" :loading="loading">
			<template v-slot:top>
				<v-toolbar dark dense color="primary" flat class="mb-1">
					<v-btn depressed class="ml-2" @click="setEmployeeSector()" color="inverted">
						<v-icon class="pr-2">mdi-plus-circle</v-icon>Sector toevoegen
					</v-btn>
				</v-toolbar>
			</template>
			<template v-slot:item.action="{ item }">
				<v-icon @click="handleClick(item.id)">mdi-account-edit</v-icon>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>
import Axios from "axios";
import { API_ROOT } from "../../config";

const ax = Axios.create({
	baseURL: API_ROOT["osbod_salary"],
	timeout: 60000
});

export default {
	name: "employee_sectors",
	data() {
		return {
			search: "",
			loadError: "",
			headers: [
				{
					text: "",
					align: "center",
					sortable: false,
					value: "action"
				},
				{ text: "Schoolyear", value: "tbl_sys_schoolyear.name" },
				{ text: "Function", value: "tbl_employee.tbl_sys_function.name" },
				{ text: "Government ID", value: "tbl_employee.government_id" },
				{ text: "Firstname", value: "tbl_employee.firstname" },
				{ text: "Maidenname", value: "tbl_employee.maidenname" },
				{ text: "Lastname", value: "tbl_employee.surname" },
				{ text: "Sector", value: "tbl_sys_sector.name" },
				{ text: "E-mail", value: "tbl_employee.email" },
				{ text: "E-mail OSBOD", value: "tbl_employee.osbod_email" }
			],
			data: [],
			loading: false
		};
	},
	created: function() {
		this.getEmployeeSector();
	},
	methods: {
		handleClick(id) {
			this.$router.push({
				path: "/schooladmin/employee_sector/update/" + id
			});
		},
		setEmployeeSector: function() {
			this.$router.push({
				path: "/schooladmin/employee_sector/new"
			});
		},
		getEmployeeSector: function() {
			var self = this;
			this.loading = true;
			this.loadError = "";
			ax.get("/employee_sector/all").then(function(response) {
				self.data = response.data;
				self.loading = false;
			}).catch(function() {
				self.loadError = "Medewerker sector gegevens konden niet worden geladen.";
				self.loading = false;
			});
		}
	}
};
</script>

<style slot-scoped>
</style>
